export const convocatorias_item = [
    {
        "nombre" : "Enero 2025",
        "url" : "/pdf/Convocatoria_Protocolo2025-1.pdf",
        "icono": "Convocatoria-protocolo2025.png"
    },
    {
        "nombre" : "Enero 2023",
        "url" : "/pdf/Convocatoria_ProtocoloC.pdf",
        "icono": "Convocatoria-protocolo.png"
    },
    {
        "nombre" : "Octubre 2023",
        "url" : "/pdf/Convocatoria_ProtocoloC2.pdf",
        "icono": "Convocatoria-protocolo2.png"
    },
]